import { createSelector } from '@reduxjs/toolkit';

import {
  getIsDescriptionModified,
  getIsLabelModified,
} from 'src/containers/ProjectDiagram/utils/draft/draftModelConcept';
import {
  getAddedRelationshipSourcesAndTargets,
  getPreviousRelationship,
} from 'src/containers/ProjectDiagram/utils/draft/draftRelationship';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';

export const relationshipDraftChangesSelector = (
  projectId: string,
  iri: string | undefined
) =>
  createSelector(diagramSnapshotSelector(projectId), (diagram) => {
    if (!diagram?.model?.modelData?.draftData || !iri) {
      return {
        isDescriptionModified: false,
        isLabelModified: false,
        addedSources: new Set<string>(),
        addedTargets: new Set<string>(),
      };
    }

    const isNewRelationship = !getPreviousRelationship(diagram, iri);

    const isDescriptionModified = getIsDescriptionModified({
      iri,
      isNewConcept: isNewRelationship,
      diagram,
    });

    const isLabelModified = getIsLabelModified({
      iri,
      isNewConcept: isNewRelationship,
      diagram,
    });

    const { addedSources, addedTargets } =
      getAddedRelationshipSourcesAndTargets({
        isNewRelationship,
        relationshipIri: iri,
        diagram,
      });

    return {
      isDescriptionModified,
      isLabelModified,
      addedSources,
      addedTargets,
    };
  });
